import React, { useEffect, useMemo } from 'react';
import { Grid, PageLoading, SpaceWrapper, StickyNavigation } from 'ui-toolkit';
import { UserProfileContainer } from 'components/userProfile/UserProfileContainer';
import { useGetSelfAdminUserQuery } from '../../API/administration/AdminUsersAPI';
import { DashboardKPIContainer } from './KPICards/DashboardKPIContainer';
import { DashboardSigningAppointmentsContainer } from './cards/signingAppointments/DashboardSigningAppointmentsContainer';
import { DashboardOrdersContainer } from './cards/orders/DashboardOrdersContainer';
import { ErrorBoundaryTW } from '../../tailwindComponents/errorBoundary/ErrorBoundaryTW';
import { useQueryStringQuery } from '../../pages/useQueryStringQuery';
import { IOrderParams } from '../../API/pcDashboard/getOrderAsync';
import { DashboardFiltersContainer } from './filter/DashboardFiltersContainer';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';
import { clientUrls } from '../../ui-toolkit/rest/ClientUrlFactory';
import { convertDataToString } from '../../utilities/queryString';
import { DashboardTasksContainer } from './cards/tasks/DashboardTasksContainer';
import { eSearchOrdersOrderBy } from '../../ui-toolkit/orders/searchOrder/types/eSearchOrdersOrderBy';

export const initialDashboardQueryObject: IOrderParams = {
  internalContacts: [],
  clientCompanies: [],
  transactionCategories: [],
  lenderCompanyIds: [],
  orderStatuses: [],
  states: [],
  city: '',
  countyId: '',
  zipCode: '',
  tag: '',
  closingDateStart: '',
  closingDateEnd: '',
  createdAtStart: '',
  createdAtEnd: '',
  pageNumber: 0,
  pageSize: 20,
  sortBy: eSearchOrdersOrderBy.createdAtDESC,
  excludeCanceledOrders: false,
  excludeInactiveOrders: false,
  settlementAgentId: '',
  underwriterId: '',
};

export const DashboardContainer: React.FC = () => {
  const { isFetching } = useReplaceParamsIfEmpty();
  const { queryObject, setQueryObject } = useQueryStringQuery<IOrderParams>(
    'dashboard',
    initialDashboardQueryObject,
    [],
    { convertBooleans: true }
  );

  const queryWithoutPagination: Omit<IOrderParams, 'pageNumber' | 'pageSize' | 'sortBy'> = useMemo(() => {
    const { pageNumber, pageSize, sortBy, ...rest } = queryObject;
    return rest;
  }, [queryObject]);

  return (
    <>
      <StickyNavigation activeMain={'Dashboard'} profile={<UserProfileContainer />} />
      <PageLoading isLoading={isFetching}>
        <ErrorBoundaryTW>
          <SpaceWrapper>
            <Grid>
              <DashboardKPIContainer />
              <DashboardFiltersContainer setQueryObject={setQueryObject} queryObject={queryObject} />
              <Grid templateColumns={'1fr 1fr'}>
                <DashboardOrdersContainer queryObject={queryObject} setQueryObject={setQueryObject} />
                <DashboardTasksContainer queryWithoutPagination={queryWithoutPagination} />
              </Grid>
              <Grid templateColumns="1fr" columnGap="spacing3" rowGap="spacing3">
                <DashboardSigningAppointmentsContainer queryWithoutPagination={queryWithoutPagination} />
              </Grid>
            </Grid>
          </SpaceWrapper>
        </ErrorBoundaryTW>
      </PageLoading>
    </>
  );
};

const useReplaceParamsIfEmpty = () => {
  const { data: self, isFetching } = useGetSelfAdminUserQuery();
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (!self || location.search) {
      return;
    }
    const defaultParams = convertDataToString({ internalContacts: [self.id] });
    history.replace(`${clientUrls.urlFor.dashboard()}?${defaultParams.toString()}`);
  }, [history, location.search, self]);
  return { isFetching };
};
